export const poolData = {
  UserPoolId: process.env.VUE_APP_UserPoolId,
  ClientId: process.env.VUE_APP_ClientId,
};
